import * as React from 'react';
import { forwardRef } from 'react';
const LabelPairedChevronRightSmBoldIcon = ({ title, titleId, ...props }, ref) => (React.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: 9, height: 22, viewBox: '0 0 9 22', role: 'img', ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", null,
        React.createElement("path", { d: 'M8.465 10.285c.246.274.246.684 0 .93l-5.25 5.25c-.274.273-.684.273-.93 0a.6.6 0 0 1 0-.902l4.785-4.786-4.785-4.812a.6.6 0 0 1 0-.902.6.6 0 0 1 .902 0z' })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: '254a9d24fe7357b7c0bfedfe22840504__a' },
            React.createElement("path", { d: 'M0 0h9v22H0z' })))));
const ForwardRef = forwardRef(LabelPairedChevronRightSmBoldIcon);
export default ForwardRef;
